/**
 * Normaliza texto para busca: minúsculas e sem acentos (NFD + remove marcas combinantes).
 * Útil para correspondência tolerante em português.
 */
export function normalizeForSearch(value: string | number | null | undefined): string {
  if (value === null || value === undefined) return ''
  return String(value)
    .normalize('NFD')
    .replace(/\p{M}/gu, '')
    .toLowerCase()
}

/** true se needle (após trim) estiver vazio ou se haystack contiver needle, ignorando acentos e caixa */
export function matchesSearchAccentInsensitive(haystack: string, needle: string): boolean {
  const n = needle.trim()
  if (!n) return true
  return normalizeForSearch(haystack).includes(normalizeForSearch(n))
}
